<template>
  <div>
    <div class="customizer-links d-none" :class="{ open: customizer }">
      <div class="nav flex-column nac-pills" id="c-pills-tab">

      </div>
    </div>
    <div class="customizer-contain" :class="{ open: customizer }">
      <div class="tab-content">
        <CustomizerConfiguration />
        <div class="customizer-body custom-scrollbar">

        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import { mapState } from 'vuex';

  import CustomizerConfiguration from './customizerconfiguration';

  

  export default {
    name: 'customizer',
    components : {
      CustomizerConfiguration
      
    },
    computed: {
      ...mapState({
        customizer: (state) => state.menu.customizer,
      }),
    },
  };
</script>